export default __webpack_public_path__ + "static/104184-ac87deab7e4ba887a60e1522e7a70145.jpg";